module.exports = __webpack_public_path__ + "static/media/button-google-play.9ca6eff1.svg";